import React from 'react';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import styles from './ImportInstructions.module.css';

const ImportInstructions = () => {
    // Dados dos campos da planilha
    const fields = [
        { name: 'Nome completo', required: true, description: 'Nome completo do paciente' },
        { name: 'CPF', required: false, description: 'Apenas números, sem pontuação' },
        { name: 'Data de nascimento', required: false, description: 'Formato DD/MM/AAAA' },
        { name: 'Sexo biológico', required: false, description: 'Opções válidas: Masculino, Feminino ou vazio' },
        { name: 'Telefone (com DDD)', required: false, description: 'Apenas números, com DDD' },
        { name: 'Email', required: false, description: 'Endereço de email válido' },
        { name: 'CEP', required: false, description: 'Apenas números' },
        { name: 'Endereço', required: false, description: 'Logradouro completo' },
        { name: 'Número', required: false, description: 'Número do endereço' },
        { name: 'Complemento', required: false, description: 'Complemento do endereço' },
        { name: 'Bairro', required: false, description: 'Bairro do endereço' },
        { name: 'Cidade', required: false, description: 'Cidade do endereço' },
        { name: 'Estado', required: false, description: 'Sigla do estado (SP, RJ, MG etc)' },
    ];

    return (
        <Paper elevation={1} className={styles.container}>
            <Box sx={{ p: 3 }}>
                <Typography variant="h6" className={styles.sectionTitle}>
                    Instruções de Preenchimento
                </Typography>
                
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" className={styles.subTitle} gutterBottom>
                        Regras Gerais:
                    </Typography>
                    <div className={styles.rulesContainer}>
                        <div className={styles.rule}>
                            <CheckCircleOutlineIcon className={styles.ruleIcon} />
                            <Typography variant="body1">Não altere a estrutura da planilha (não adicione ou remova colunas)</Typography>
                        </div>
                        <div className={styles.rule}>
                            <CheckCircleOutlineIcon className={styles.ruleIcon} />
                            <Typography variant="body1">Preencha todos os campos obrigatórios</Typography>
                        </div>
                        <div className={styles.rule}>
                            <CheckCircleOutlineIcon className={styles.ruleIcon} />
                            <Typography variant="body1">Siga os formatos especificados para cada campo</Typography>
                        </div>
                        <div className={styles.rule}>
                            <CheckCircleOutlineIcon className={styles.ruleIcon} />
                            <Typography variant="body1">Não inclua cabeçalhos ou linhas em branco</Typography>
                        </div>
                        <div className={styles.rule}>
                            <CheckCircleOutlineIcon className={styles.ruleIcon} />
                            <Typography variant="body1">Cada linha deve conter os dados de um único paciente</Typography>
                        </div>
                    </div>
                </Box>
                
                <Divider sx={{ my: 3 }} />
                
                <Typography variant="subtitle1" className={styles.subTitle} gutterBottom>
                    Campos da Planilha:
                </Typography>
                
                <TableContainer className={styles.tableContainer}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell className={styles.tableHeader}>Campo</TableCell>
                                <TableCell className={styles.tableHeader}>Obrigatório</TableCell>
                                <TableCell className={styles.tableHeader}>Observações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fields.map((field) => (
                                <TableRow key={field.name} className={field.required ? styles.requiredRow : ''}>
                                    <TableCell className={styles.fieldName}>{field.name}</TableCell>
                                    <TableCell>
                                        {field.required ? 
                                            <span className={styles.requiredBadge}>Sim</span> : 
                                            <span className={styles.optionalBadge}>Não</span>
                                        }
                                    </TableCell>
                                    <TableCell>{field.description}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                
                <Box sx={{ mt: 3 }} className={styles.infoBox}>
                    <WarningAmberIcon className={styles.infoIcon} />
                    <Typography variant="body2">
                        Após preencher a planilha, envie-a para o email <strong>suporte@gabriela.app.br</strong> com o assunto "Importação de Pacientes - [Nome da sua clínica]".
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
};

export default ImportInstructions;